import React from "react";
import Feature from "./Feature";
import Partners from "./Partners";

const PartnerSection = () => {
  return (
    <div className="bg-transparent">
      {/* Partner Section */}
      <section className="pt-[100px] lg:pt-[80px] w-full" data-aos="fade-up">
        <div className="max-w-screen-xl mx-auto px-4">
          <div className="flex items-center justify-between">
            <span className="flex-1 h-px bg-textGray" />
            <h2 className="text-center text-sm sm:text-dry text-dry uppercase font-semibold mx-4 whitespace-nowrap">
              Lokalai has been featured in
            </h2>
            <span className="flex-1 h-px bg-textGray" />
          </div>

          {/* Slider */}
          <div className="mt-8 lg:mt-10">
            <Partners />
          </div>
        </div>
      </section>

      {/* Feature Section */}
      <section className="py-[50px]">
        <div className="max-w-screen-xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-10">
            <Feature />
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnerSection;
